import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'OpenNote',
  path: '/:language?/opennote',
  component: Layout,
  redirect: '/opennote/detail',
  children: [
    {
      name: 'opennoteIndex',
      path: 'detail',
      component: () => import('@/views/opennote/index.vue'),
      meta: {
        hideTab: false,
        menu: 'opennoteDetail',
        image: '',
        ...getLocalizedMeta('detailOpenNote')
      }
    }
  ]
}
